import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

const Instrument_Check_Report_Table = ({ setEdit }) => {
  const data = [
    {
      date: "01 JAN 2025",
      instrumentId: "INS101",
      instrumentName: "Coal Testing Machine",
      checkPoints: [
        "Water Level",
        "Ignition Wise",
        "Chiller Unit",
        "Oxygen Pressure",
        "Working Temp",
        "Electrical Wires",
      ],
      breakDownFrom: "No Break",
      breakDownTo: "No Break",
      nextDue: "1 MAR 2025",
      inspectionType: "Internal",
      checkedBy: "Rahul Mali",
      remarks: [
        "No Remark (Water Level)",
        "No Remark (Ignition Wise)",
        "No Remark (Chiller Unit)",
        "No Remark (Oxygen Pressure)",
        "No Remark (Working Temp)",
        "No Remark (Electrical Wires)",
      ],
    },
    {
      date: "02 JAN 2025",
      instrumentId: "INS101",
      instrumentName: "Coal Testing Machine",
      checkPoints: [
        "Water Level",
        "Ignition Wise",
        "Chiller Unit",
        "Oxygen Pressure",
        "Working Temp",
        "Electrical Wires",
      ],
      breakDownFrom: "No Break",
      breakDownTo: "No Break",
      nextDue: "1 MAR 2025",
      inspectionType: "External",
      checkedBy: "Rahul Mali",
      remarks: [
        "No Remark (Water Level)",
        "No Remark (Ignition Wise)",
        "No Remark (Chiller Unit)",
        "No Remark (Oxygen Pressure)",
        "No Remark (Working Temp)",
        "No Remark (Electrical Wires)",
      ],
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th rowspan="2">
                  <input type="checkbox" />
                </th>
                <th rowspan="2">Date</th>
                <th rowspan="2">Instrument ID</th>
                <th rowspan="2">Instrument Name</th>
                <th rowspan="2">Maintenance Check Points</th>
                <th colspan="2">Break Down</th>
                <th rowspan="2">Next Due On</th>
                <th rowspan="2">Internal / External</th>
                <th rowspan="2">Check By</th>
                <th rowspan="2">Remarks</th>
              </tr>
              <tr>
                <th>From</th>
                <th>To</th>
              </tr>
            </thead>

            <tbody>
              {data.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{row.date}</td>
                  <td>{row.instrumentId}</td>
                  <td>{row.instrumentName}</td>
                  <td>
                    <table className="inner-table">
                      <tbody>
                        {row.checkPoints.map((point, i) => (
                          <tr key={i}>
                            <td>{point}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>
                  <td>{row.breakDownFrom}</td>
                  <td>{row.breakDownTo}</td>
                  <td>{row.nextDue}</td>
                  <td>{row.inspectionType}</td>
                  <td>{row.checkedBy}</td>
                  <td>
                    <table className="inner-table">
                      <tbody>
                        {row.remarks.map((remark, i) => (
                          <tr key={i}>
                            <td>{remark}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Instrument_Check_Report_Table;
